import axios from "axios";
import apiUrlOne from "../Config";

// Get all product tabs
export const getAllProductTabs = async () => {
    const response = await axios.get(`${apiUrlOne}/producttabs/getall-producttab`);
    return response.data;
};


// Create product tab
export const createProductTab = async (formData) => {
    const response = await axios.post(`${apiUrlOne}/producttabs/create-producttab`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Update product tab
export const updateProductTab = async (id, formData) => {
    const response = await axios.put(`${apiUrlOne}/producttabs/update-producttab/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

// Delete product tab
export const deleteProductTab = async (id) => {
    const response = await axios.delete(`${apiUrlOne}/producttabs/delete-producttab/${id}`);
    return response.data;
};

// Get product tab by id
export const getProductTabById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/producttabs/getproducttab/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching product tab:", error);
        throw error;
    }
};


export const getProductTabsByProductId = async (productId) => {
    const response = await axios.get(`${apiUrlOne}/producttabs/getproducttabs?productId=${productId}`);
    return response.data;
};


